var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{attrs:{"app":""}},[_c('v-layout',{staticClass:"pa-1",attrs:{"column":"","fill-height":""}},[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1),_c('a',{attrs:{"href":"https://www.freepik.com/vectors/background"}},[_vm._v("Background vector created by renata.s - www.freepik.com")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }